import PropTypes from "prop-types";
import { React, useRef } from "react";

//Chakra
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

const FormConfirmButton = (props) => {
  // VARIABLES ===============================================================
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);

  //Props
  const { formik, dialog, buttonText } = props;
  const button_color_scheme = props?.buttonColor ?? "green";
  const textTransform = props?.textTransform ?? "uppercase";

  // FUNCTIONS ==============================================================

  return (
    <>
      <Button
        variant="brand"
        fontSize="15px"
        type="submit"
        w="100%"
        maxW="350px"
        h="45"
        mb="20px"
        mt="20px"
        mx={"2"}
        textTransform={textTransform}
        fontWeight={"extrabold"}
        backgroundColor={"gray.600"}
        onClick={() => {
          window.history.back();
        }}
      >
        Back
      </Button>
      <Button
        variant="brand"
        fontSize="15px"
        type="submit"
        w="100%"
        maxW="350px"
        h="45"
        mb="20px"
        mt="20px"
        mx={"2"}
        textTransform={textTransform}
        fontWeight={"extrabold"}
        backgroundColor={dialog.button_color}
        isLoading={formik.isSubmitting}
        onClick={onOpen}
        isDisabled={formik.isLoading}
      >
        {buttonText}
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {dialog.header}
            </AlertDialogHeader>

            <AlertDialogBody>{dialog.body}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme={button_color_scheme}
                onClick={() => {
                  formik.submitForm();
                  onClose();
                }}
                ml={3}
              >
                {dialog.confirm}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

FormConfirmButton.propTypes = {
  buttonText: PropTypes.string,
  dialog: PropTypes.object,
  formik: PropTypes.any,
};

export default FormConfirmButton;
